export default __webpack_public_path__ + "static/media/copy-red.3b6b7d8e.svg";